export const INTERACTIVE_CARD =
  'cursor-pointer transition-all duration-200 hover:-translate-y-0.5 hover:border-primary-blue hover:shadow-[0px_6px_16px_rgba(0,0,0,0.35)]'
